import { Component } from '@angular/core';
import { StatisticsService } from '../../../../services/statistics.service';
import { CommonModule, formatDate } from '@angular/common';
import { DesignAngularKitModule, ItNotificationService, NotificationPosition } from 'design-angular-kit';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { format } from 'date-fns';
import { it } from 'date-fns/locale';
import { AuthService } from '../../../../services/auth.service';
import { ContextService } from '../../../../services/context.service';
import { KeycloakService } from 'keycloak-angular';
import { RequestService } from '../../../../services/request.service';

@Component({
  selector: 'app-stats-table-entity-exploded-manage',
  standalone: true,
  imports: [
    CommonModule,
    DesignAngularKitModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  templateUrl: './stats-table-entity-exploded-manage.component.html',
  styleUrl: './stats-table-entity-exploded-manage.component.scss',
})
export class StatsTableEntityExplodedManageComponent {
  form: FormGroup;
  data: { totals: any; values: any[]; } = {totals: null, values: []};
  sortedData: any[] = [];
  totals: any = {};
  selectedStartDate: string | null = null;
  selectedEndDate: string | null = null;
  year: string | null = null;
  trimestre: string | null = null;
  entities: any[] = [];

  constructor(
    private statisticsService: StatisticsService,
    private fb: FormBuilder,
    private notification: ItNotificationService,
    private keycloakService: KeycloakService,
    private requestService: RequestService
  ) {
    const currentYear = new Date().getFullYear();
    const currentDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.form = this.fb.group({
      dataInizio: [`${currentYear}-01-01`],
      dataFine: [`${currentDate}`],
      state: ['ALL'],
      explode: [true],
      aslCode: [],
      entityTypes: []
    });
  }

  async ngOnInit(): Promise<void> {
    const profile = await this.keycloakService.loadUserProfile();
    const aslCodes: string[] =
      Array.isArray(profile.attributes?.['ASL']) &&
      typeof profile.attributes?.['ASL'][0] === 'string'
        ? profile.attributes?.['ASL'][0].split(',').map((s) => s.trim()).filter(Boolean)
        : [];
    this.form.get('state')?.setValue('ALL');
    if(aslCodes && aslCodes[0]) {
      this.form.get('aslCode')?.setValue(aslCodes[0]);
    }
    this.requestService.loadActors(false).subscribe(result => {
      if(result?.length) {
        this.entities = [];
        result.forEach(a => {
          if(a['subcategoryNames'].length) {
            a['subcategoryNames'].forEach((sub: any) => {
              this.entities.push(sub);
            });
          } else {
            this.entities.push(a)
          }
        });
      }
    });
    this.search();
  }


  selectedTrimester() {
    if(this.trimestre == '1') {
      this.form.controls['dataInizio'].setValue(this.year+'-01-01');
      this.form.controls['dataFine'].setValue(this.year+'-03-31');
    }
    if(this.trimestre == '2') {
      this.form.controls['dataInizio'].setValue(this.year+'-04-01');
      this.form.controls['dataFine'].setValue(this.year+'-06-30');
    }
    if(this.trimestre == '3') {
      this.form.controls['dataInizio'].setValue(this.year+'-07-01');
      this.form.controls['dataFine'].setValue(this.year+'-09-30');
    }
    if(this.trimestre == '4') {
      this.form.controls['dataInizio'].setValue(this.year+'-10-01');
      this.form.controls['dataFine'].setValue(this.year+'-12-31');
    }
  }

  search() {
    const { dataInizio, dataFine } = this.form.value;
    if(dataInizio.substring(0,4)<2024) {
      this.notification.warning(
              'Attenzione.',
              'Non è possibile fare una ricerca per pratiche antecedenti al 2024.',
              true,
              3000,
              NotificationPosition.Top
            );
            return;
    }
    this.selectedStartDate = dataInizio;
    this.selectedEndDate = dataFine;
    let request = {
        startDate: dataInizio,
        endDate: dataFine,
        state: this.form.controls['state'].value,
        explode: true,
        aslCode: this.form.controls['aslCode'].value,
        entityTypes: this.form.controls['entityTypes'].value,
        isReportingEntity: false
      }
      if(!this.form.controls['entityTypes'].value || this.form.controls['entityTypes'].value == 'null') {
        delete request['entityTypes'];
      } else {
        request['entityTypes'] = [this.form.controls['entityTypes'].value];
      }
      if(!(this.form.controls['aslCode'].value != 'null')) {
        delete request['aslCode'];
      }
    this.statisticsService
      .getStatsEntity(request)
      .subscribe((res) => {
        this.data = res;
        this.computeTotals();
      });
  }

  clearFilter() {
    this.form!.patchValue({ dataInizio: null, dataFine: null, state:'ALL' });
    this.selectedStartDate = null;
    this.selectedEndDate = null;
    this.search();
  }

  computeTotals() {
    this.totals = {};
    this.totals = this.data.totals;
  }

  formatSetting(setting: string): string {
    if (setting?.toLowerCase() === 'altro') {
      return 'Altro';
    }
    return setting;
  }

  formatDateIT(dateStr: string | null): string {
    if (!dateStr) return '';
    return format(new Date(dateStr), 'dd/MM/yyyy', { locale: it });
  }
}
